import * as React from "react";

const ImageCarouselNext: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="48" viewBox="0 0 28 48" fill="none">
            <path
                d="M10.0793 33L9 31.9208L16.7115 24.2108L9.0015 16.5L10.0793 15.4215L18.3293 23.6715L18.8445 24.2108L18.3293 24.75L10.0793 33Z"
                fill="#0071AD"
            />
        </svg>
    );
};

export default React.memo(ImageCarouselNext);
